var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcCamera = function SvgIcCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 25,
    fill: "none",
    viewBox: "0 0 30 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D85FF",
    fillRule: "evenodd",
    d: "M9.374 13.5a5.625 5.625 0 1 1 11.25 0 5.625 5.625 0 0 1-11.25 0M15 10.125a3.375 3.375 0 1 0 0 6.75 3.375 3.375 0 0 0 0-6.75",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D85FF",
    fillRule: "evenodd",
    d: "M12.923 2.625a2.84 2.84 0 0 0-2.838 2.839c0 .999-.767 1.83-1.763 1.911l-3.344.272a1.46 1.46 0 0 0-1.32 1.186 31.2 31.2 0 0 0-.148 10.772l.146.906a1.88 1.88 0 0 0 1.706 1.578l2.914.236c4.475.364 8.971.364 13.446 0l2.914-.236a1.88 1.88 0 0 0 1.706-1.578l.146-.906a31.2 31.2 0 0 0-.148-10.772 1.46 1.46 0 0 0-1.32-1.186l-3.344-.272a1.92 1.92 0 0 1-1.762-1.911 2.84 2.84 0 0 0-2.84-2.839zm-5.08 2.532a5.09 5.09 0 0 1 5.08-4.782h4.152a5.09 5.09 0 0 1 5.08 4.782l3.048.247a3.71 3.71 0 0 1 3.347 3.01c.722 3.812.776 7.72.16 11.549l-.146.906a4.13 4.13 0 0 1-3.746 3.462l-2.914.237a85 85 0 0 1-13.81 0L5.18 24.33a4.13 4.13 0 0 1-3.745-3.462l-.146-.906a33.5 33.5 0 0 1 .159-11.549 3.71 3.71 0 0 1 3.348-3.01z",
    clipRule: "evenodd"
  })));
};
export default SvgIcCamera;